import React, { useState, useEffect } from 'react'
import { Row, Col } from 'react-bootstrap'
import thumbnail from '../../../../img/company.png'
import { useDispatch, useSelector } from 'react-redux'
import PipelineLoader from '../dashboard-pipeline-loader'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import NumberFormat from 'react-number-format'
import uuid from 'uuid/dist/v4'
import { changePipelineModal, requestMovePipelineData, retrieveSinglePipelineDetails, setActivePipelineUnit, retrieveAllPipelines, resetAllPipelines, resetActivePipelineUnit, resetMovePipelineData, resetDeletePipelineUnit, resetUpdatePipelineUnit } from '../../../../redux/actions/pipeline'
import moment from 'moment'

import './style.scss'



const Index = () => {

    const dispatch = useDispatch()

    const [_, setInitialLoad] = useState(true)
    const [canReRender, setCanReRender] = useState(false)
    const [activeMove, setActiveMove] = useState({})

    const selectedCompany = useSelector(state => state && state.activeCompany && state.activeCompany.activeCompany && state.activeCompany.activeCompany.id)
    const userLoading = useSelector(state => state.user.fetchUserDetails.loading)

    const allPipelines = useSelector(state => state.pipeline.selections)
    const data = useSelector(state => state.pipeline.activePipeline && state.pipeline.activePipeline.data)
    const units = useSelector(state => state.pipeline.activePipeline && state.pipeline.activePipeline.units)

    const activePipeline = useSelector(state => state.pipeline.activePipeline?.id)
    const updateLoading = useSelector(state => state.pipeline.updatedData.loading)

    const fetchAllPipelinesLoading = useSelector(state => state.pipeline.fetchAllPipelines.loading)
    const fetchAllPipelinesStatus = useSelector(state => state.pipeline.fetchAllPipelines.status)

    const fetchSinglePipelineLoading = useSelector(state => state.pipeline.fetchSinglePipeline.loading)
    const fetchSinglePipelineStatus = useSelector(state => state.pipeline.fetchSinglePipeline.status)

    const flushDetails = () => {
        dispatch(resetAllPipelines())
        dispatch(resetActivePipelineUnit())
        dispatch(resetMovePipelineData())
        dispatch(resetDeletePipelineUnit())
        dispatch(resetUpdatePipelineUnit())
    }

    useEffect(() => {
        flushDetails()
    }, [])

    const [columns, setColumns] = useState({
        [uuid()]: {
            name: "Laster inn..",
            items: []
        },
        [uuid()]: {
            name: "Laster inn..",
            items: []
        },
        [uuid()]: {
            name: "Laster inn..",
            items: []
        },
        [uuid()]: {
            name: "Laster inn..",
            items: []
        },
        [uuid()]: {
            name: "Laster inn..",
            items: []
        },
        [uuid()]: {
            name: "Laster inn..",
            items: []
        }
    })



    const onDragEnd = (result, stateColumns, setStateColumns) => {
        if (!result.destination) return;
        const { source, destination } = result;
      
        if (source.droppableId !== destination.droppableId) {
            const sourceColumn = stateColumns[source.droppableId];
            const destColumn = stateColumns[destination.droppableId];
            const sourceItems = [...sourceColumn.items];
            const destItems = [...destColumn.items];
            const [removed] = sourceItems.splice(source.index, 1);
            destItems.splice(destination.index, 0, removed);
            setStateColumns({
                ...stateColumns,
                [source.droppableId]: {
                ...sourceColumn,
                items: sourceItems
                },
                [destination.droppableId]: {
                ...destColumn,
                items: destItems
                }
            })
            setCanReRender(true)
            setActiveMove({companyId: selectedCompany, pipelineId: activePipeline, sourceId: source.droppableId, destinationId: destination.droppableId})
        } else {
            const column = stateColumns[source.droppableId];
            const copiedItems = [...column.items];
            const [removed] = copiedItems.splice(source.index, 1);
            copiedItems.splice(destination.index, 0, removed);
            setStateColumns({
                ...stateColumns,
                [source.droppableId]: {
                ...column,
                items: copiedItems
                }
            })
            setCanReRender(true)
            setActiveMove({companyId: selectedCompany, pipelineId: activePipeline, sourceId: source.droppableId})
        }
      }


    const retrieveAmount = id => {
        
        var amount = 0
        for(var price in data){
            if(data[price].target === id){
                amount += data[price].amount
            }
        }
        return `${amount}kr`
    }

    const clickEditUnit = item => {
        dispatch(changePipelineModal({editUnitPipelineModal: true}))
        dispatch(setActivePipelineUnit({
            id: item.id, 
            title: item.title, 
            description: item.description, 
            amount: item.amount, 
            contactPerson: item.contactPerson, 
            type: item.type
        }))
    }

    const clickDeleteUnit = item => {
        dispatch(changePipelineModal({deletePipelineUnitModal: true}))
        dispatch(setActivePipelineUnit({
            id: item.id, 
            title: item.title, 
            description: item.description, 
            amount: item.amount, 
            contactPerson: item.contactPerson
        }))
    }

    useEffect(() => {
        if(selectedCompany){
            flushDetails()
            setColumns({
                [uuid()]: {
                    name: "Laster inn..",
                    items: []
                },
                [uuid()]: {
                    name: "Laster inn..",
                    items: []
                },
                [uuid()]: {
                    name: "Laster inn..",
                    items: []
                },
                [uuid()]: {
                    name: "Laster inn..",
                    items: []
                },
                [uuid()]: {
                    name: "Laster inn..",
                    items: []
                },
                [uuid()]: {
                    name: "Laster inn..",
                    items: []
                }
            })
            dispatch(retrieveAllPipelines({companyId: selectedCompany}))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCompany])


    useEffect(() => {
        if(fetchAllPipelinesStatus === "success" && allPipelines.length > 0){
            dispatch(retrieveSinglePipelineDetails({companyId: selectedCompany, pipelineId: allPipelines[0].id}))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, fetchAllPipelinesStatus, allPipelines)

    useEffect(() => {
        if(fetchSinglePipelineStatus === "success" && activePipeline){
            if(units && units.length > 0 && !userLoading && selectedCompany){
                const allUnits = {}
                for(var unit in units){
                    if(data && data.length > 0){
                        const allData = []
                        for(var item in data){
                            if(data[item].target === units[unit].id){
                                allData.push(data[item])
                            }
                        }
                        allUnits[units[unit].id] = {name: units[unit].name, order: units[unit].order, items: allData}
                    } else {
                        allUnits[units[unit].id] = {name: units[unit].name, order: units[unit].order, items: []}
                    }
                }
                setColumns(allUnits)
                setInitialLoad(false)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchSinglePipelineStatus, activePipeline])

    useEffect(() => {
        if(canReRender && Object.keys(activeMove).length > 0){
            if(activeMove.destinationId){
                dispatch(requestMovePipelineData({companyId: selectedCompany, pipelineId: activePipeline, sourceId: activeMove.sourceId, sourceItems: columns[activeMove.sourceId].items, destinationId: activeMove.destinationId, destinationItems: columns[activeMove.destinationId].items}))
            } else{
                dispatch(requestMovePipelineData({companyId: selectedCompany, pipelineId: activePipeline, sourceId: activeMove.sourceId, sourceItems: columns[activeMove.sourceId].items}))
            }
            setCanReRender(false)
            setActiveMove(null)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [columns, canReRender, activeMove])

    return(
        <section className="pipeline-flow-section">
            <div className="inner-pipeline-flow-container">
                <div className="pipeline-scroll-container">
                    <DragDropContext onDragEnd={result => onDragEnd(result, columns, setColumns)}>
                        <Row className="pipeline-row flex-nowrap">
                            {Object.entries(columns).map(([columnId, column], index) => {
                                return (
                                    <div style={{display: "flex", flexDirection: "column", alignItems: "center", margin: 10}} key={columnId}>
                                        <Row className="upper-pipe-row">
                                            <Col className="title-col my-auto text-left">
                                                <h3 className="single-pipe-title">{column.name}</h3>
                                            </Col>
                                            <Col className="amount-col my-auto text-right">
                                                <label className="single-pipe-amount">{updateLoading ? <i className="fas fa-circle-notch fa-spin"></i>:<NumberFormat thousandSeparator={' '} displayType={'text'} value={retrieveAmount(columnId)} />}kr</label>
                                            </Col>
                                        </Row>

                                        <div style={{ margin: 0}}>
                                        <Droppable droppableId={columnId} key={columnId}>
                                            {(provided, snapshot) => {
                                                return (
                                                <div {...provided.droppableProps} ref={provided.innerRef} style={{ width: 325, minHeight: 590, maxHeight: 590, height: '100%', overflowY: 'scroll', borderRadius: '8px', background: column.items.length > 0 ? "#F4F6F9":"#F4F6F9"}}>
                                                    {column.items.map((item, index) => {
                                                    return (
                                                        <Draggable key={item.id} draggableId={item.id} index={index}>
                                                            {(provided, snapshot) => {
                                                                return (
                                                                <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} style={{borderRadius: '4px', userSelect: "none", padding: '15px 20px', margin: "10px 10px 14px 10px", minHeight: "50px", borderColor: 'rgb(231, 231, 231)', backgroundColor: '#FFF', borderWidth: '0px', borderStyle: 'solid', color: "black", ...provided.draggableProps.style}}>
                                                                    <Row className="company-upper-row">
                                                                        <Col className="thumbnail-col my-auto">
                                                                            <img alt="Bedrift" className="company-thumbnail" src={thumbnail}/>
                                                                        </Col>
                                                                        <Col className="name-col my-auto">
                                                                            <h5 className="company-name">{item.name ? item.name:"Ikke oppgitt"}</h5>
                                                                        </Col>
                                                                        <Col className="edit-col text-right my-auto">
                                                                            <button onClick={() => clickEditUnit(item)} className="edit-button"><i class="far fa-edit"></i></button>
                                                                            <button onClick={() => clickDeleteUnit(item)} className="delete-button"><i class="far fa-trash-alt"></i></button>
                                                                        </Col>
                                                                    </Row>
                                                                    <div className="all-details-container">
                                                                        <h4 className="details-title">{item.title ? item.title:"Ingen tittel."}</h4>
                                                                        <p className="details-description">{item.description ? item.description:"Ingen beskrivelse tilgjengelig."}</p>
                                                                    </div>
                                                                    <Row className="company-bottom-row">
                                                                        <Col className="name-col text-left">
                                                                            <label><i class="fad fa-clock"></i> {item.dateAdded ? moment.unix(item.dateAdded).format('DD/MM/YYYY HH:MM'):"Ikke tilgjengelig"}</label>
                                                                        </Col>
                                                                        <Col className="amount-col text-right">
                                                                            <label><NumberFormat thousandSeparator={' '} displayType={'text'} value={item.amount ? item.amount:null} />kr</label>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                                );
                                                            }}
                                                        </Draggable>
                                                    );
                                                    })}
                                                    {provided.placeholder}
                                                </div>
                                                );
                                            }}
                                            </Droppable>
                                        </div>
                                    </div>
                                );
                            })}
                        </Row>
                    </DragDropContext>
                </div>
                {fetchSinglePipelineLoading || fetchAllPipelinesLoading ? <PipelineLoader/>:null}
            </div>
        </section>
    )
}

export default Index



